export const IN4X_ACTION_DEPOSIT = 'deposit';
export const IN4X_ACTION_WITHDRAW = 'withdraw';
export const IN4X_ACTION_PAY = 'pay';

export const IN4X_METHOD_WIRE = 'wire';
export const IN4X_METHOD_OTC = 'otc';
export const IN4X_METHOD_CARD = 'card';
export const IN4X_METHOD_ANY = 'any';
export const IN4X_METHOD_SWAP = 'swap';